import { connect } from 'react-redux';
import ViewSitedetails from './viewSitedetails';
import { bindActionCreators } from 'redux';
import {siteDismantle } from 'services/redux/installation/siteStages/action';
import {
  getDetails,
  giveRating,
  getRating,
  changeSiteState,
  getSiteState,
  changeSiteStateAsExpired,
  changeSiteStateLegalEnable
} from 'services/redux/brandActivtion/sitesListing/action';

const mapStateToProps = (state) => ({
  viewDetails: state.baSiteListingReducer.viewDetails,
  siteEnableDisable: state.baSiteListingReducer.siteEnableDisable,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getDetails,
      giveRating,
      getRating,
      siteDismantle,
      changeSiteState,
      getSiteState,
      changeSiteStateAsExpired,
      changeSiteStateLegalEnable
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ViewSitedetails);
